import '../followup.scss'
import { useEffect, useMemo, useState } from 'react'
import { Formik, Form, ErrorMessage } from 'formik'
import * as Yup from 'yup'
import Button from '../../../../components/button/Button'
import PageDropdown from '../../../../components/page-dropdown/PageDropdown'
import locaionIcon from '../../../../assets/icons/location-icon.svg'
import CourseIcon from '../../../../assets/icons/CourseRedIcon.svg'
import { useNavigate, useParams } from 'react-router-dom'
import { preferredBatch, priority, ROUTES_PATH, UI_CONSTANT } from '../../../../utility/constants'
import BreadCrumbs from '../../../../components/breadcrumb/Breadcrumb'
import Calendar from '../../../../components/calendar/Calendar'
import {
  capitalizeFirstLetter,
  convertDateFormatCalendar,
  generateDropdownOptions,
} from '../../../../utility/genricFunction'
import { useDispatch, useSelector } from 'react-redux'
import { createFollowup, getFollowupHistory } from '../../../../store/builders/inquiry/followup.builder'
import dayjs from 'dayjs'
import { VALIDATION_MESSAGES } from '../../../../utility/constantValidationMessages'

const InquiryFollowUpForm = ({ inquiryId, studentInquiry }) => {
  const [selectedStatus, setSelectedStatus] = useState('alive')
  const { loading } = useSelector((state) => state.followup)
  const { batchData } = useSelector((state) => state?.branch)
  const batches = batchData?.result?.batches
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const initialValues = useMemo(
    () => ({
      followupDate: studentInquiry.followupDate || dayjs(),
      remarks: '',
      preferredBatch: studentInquiry.preferredBatch || '',
      planningJoinOn: studentInquiry.planningJoinOn || null,
      priority: studentInquiry.priority || '',
      inquiryStatus: 'alive',
      nextFollowupDate: null,
    }),
    [studentInquiry],
  )

  const validationSchema = Yup.object().shape({
    followupDate: Yup.string().required(VALIDATION_MESSAGES.FOLLOWUP_DATE),
    // followupRemarks: Yup.string(),
    // preferredBatch: Yup.string().required('Preferred Batch is required'),
    // planningJoinOn: Yup.string().required('Planning Join On is required'),
    priority: Yup.string().required(VALIDATION_MESSAGES.PRIORITY_REQUIRED),
    // nextFollowupDate: Yup.string().required('Next Follow-up Date is required'),
  })

  const handleSubmit = (values) => {
    dispatch(createFollowup({ ...values, inquiryId: inquiryId, navigate }))
  }

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={handleSubmit}
      enableReinitialize
    >
      {({ setFieldValue, values, handleChange, handleSubmit }) => (
        <Form>
          <div className='followupForm'>
            <div className='followupForm-inner-header'>
              <h1>Submit Form</h1>
            </div>
            <div className='mainClass'>
              <div className='labelClass'>
                <div className='innerClass'>
                  <Calendar
                    label='Followup Date'
                    // width='48%'
                    required
                    name='followupDate'
                    value={values.followupDate}
                    onChange={(values) => setFieldValue('followupDate', convertDateFormatCalendar(values))}
                    defaultToToday={true}
                    disabled={true}
                  />

                  <div className='followupForm-input'>
                    <label htmlFor=''>Preferred Batch</label>
                    <PageDropdown
                      options={preferredBatch}
                      selectedValue={values.preferredBatch}
                      className={'followupForm-dropdown'}
                      onChange={handleChange}
                      name={'preferredBatch'}
                      placeholder={'Select batch'}
                    />
                    <ErrorMessage name='preferredBatch' component='div' className='error-msg' />
                  </div>
                </div>
                <div className='innerClass'>
                  <div className='followupForm-input-textarea'>
                    <label htmlFor=''>Followup Remarks</label>
                    <textarea placeholder='Enter here...' rows={2} cols={1} name='remarks' onChange={handleChange} />
                    <ErrorMessage name='remarks' component='div' className='error-msg' />
                  </div>
                </div>
              </div>
              <div className='labelClass'>
                <div className='innerClass'>
                  <div className='followupForm-input'>
                    <label htmlFor=''>
                      Priority<span className='required-symbol'>*</span>
                    </label>
                    <PageDropdown
                      options={priority}
                      selectedValue={values.priority}
                      className={'followupForm-dropdown'}
                      onChange={handleChange}
                      name={'priority'}
                      placeholder={'Select priority'}
                    />
                    <ErrorMessage name='priority' component='div' className='error-msg' />
                  </div>
                </div>
                <div className='innerClass'>
                  <Calendar
                    label='Planning Join On'
                    // width='48%'
                    name='planningJoinOn'
                    value={values.planningJoinOn}
                    onChange={(values) => setFieldValue('planningJoinOn', convertDateFormatCalendar(values))}
                  />
                </div>
              </div>
              <div className='labelClass'>
                <div className='innerClass'>
                  <Calendar
                    label='Next Follow-Up Date'
                    name='nextFollowupDate'
                    // width='48%'
                    value={values.nextFollowupDate}
                    onChange={(values) => setFieldValue('nextFollowupDate', convertDateFormatCalendar(values))}
                  />
                </div>
                <div className='innerClass'>
                  <div className='followupForm-input'>
                    <label htmlFor=''>Followup Stage</label>
                    <div className='button-group'>
                      <Button
                        customClassName={selectedStatus === 'alive' ? 'active-btn' : 'inactive-btn'}
                        type='button'
                        onClick={() => {
                          setSelectedStatus('alive')
                          setFieldValue('inquiryStatus', 'alive') // Update Formik state
                        }}
                      >
                        Alive
                      </Button>
                      <Button
                        customClassName={selectedStatus === 'dead' ? 'active-btn' : 'inactive-btn'}
                        type='button'
                        onClick={() => {
                          setSelectedStatus('dead')
                          setFieldValue('inquiryStatus', 'dead') // Update Formik state
                        }}
                      >
                        Dead
                      </Button>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className='submit-btn'>
              <Button customClassName={'save-btn'} onClick={handleSubmit}>
                {loading ? UI_CONSTANT.LOADING : 'Submit Now'}
              </Button>
            </div>
          </div>
        </Form>
      )}
    </Formik>
  )
}

const FollowUpHistory = ({ followupHistory }) => {
  const convertDate = (dateString) => {
    if (!dateString) return null
    const [day, month, year] = dateString.split('-')
    return new Date(`${year}-${month}-${day}`)
  }

  // Check if any followupDate is null
  const hasFollowupDate = followupHistory && followupHistory.some((event) => event.followupDate)

  // Sort the followupHistory array by followupDate
  const sortedHistory = [...followupHistory].sort((a, b) => {
    const dateA = convertDate(a.followupDate)
    const dateB = convertDate(b.followupDate)
    return dateA - dateB
  })
  return (
    <>
      <div className='history-inner-header'>
        <h1>Follow-up History</h1>
      </div>
      <div className='timeline'>
        {hasFollowupDate ? (
          sortedHistory?.map(
            (event, index) =>
              event.followupDate && (
                <div className='tl-content tl-content-active' key={index}>
                  <div className='tl-header'>
                    <span className='tl-marker'></span>
                    <time className='tl-time'>{event.followupDate}</time>
                  </div>
                  <div className='tl-body'>
                    <p>{event.remarks}</p>
                    <div className='historyFooter'>
                      <span>{event.inquiryType}</span>
                      <span className='squarebox'></span>
                      <span className='follow-up-date'>Next Follow-Up Date: {event.nextFollowupDate || 'N/A'}</span>
                    </div>
                  </div>
                </div>
              ),
          )
        ) : (
          <div className='no-history-message'>
            <p>{UI_CONSTANT.INQUIRY.FOLLOWUP_HISTORY_MESSAGE}</p>
          </div>
        )}
      </div>
    </>
  )
}

const FollowupForm = () => {
  const { id } = useParams()
  const dispatch = useDispatch()
  const [studentInquiry, setStudentInquiry] = useState()
  const [activeTab, setActiveTab] = useState('followUp')
  const { allInquiryData } = useSelector((state) => state.inquiry)
  const { followupHistory } = useSelector((state) => state.followup)

  useEffect(() => {
    if (id && allInquiryData.length > 0) {
      const StudentInquiry = allInquiryData.find((inquiry) => {
        return inquiry.inquiryId === id
      })
      setStudentInquiry(StudentInquiry)
    }

    dispatch(getFollowupHistory(id))
  }, [id, allInquiryData])

  const breadCrumbsArr = [
    {
      title: UI_CONSTANT.INQUIRY.LABEL_INQUIRY,
      link: null,
    },
    {
      title: UI_CONSTANT.DASHBOARD,
      link: ROUTES_PATH.DASHBOARD,
    },
    {
      title: UI_CONSTANT.INQUIRY.LABEL_INQUIRY,
      link: ROUTES_PATH.INQUIRY,
    },
    {
      title: UI_CONSTANT.INQUIRY.INQUIRY_FOLLOWUP,
      link: ROUTES_PATH.FOLLOW_UP_LIST_CREATE.replace(':id', id),
    },
  ]
  const getInitials = (name) => {
    const nameParts = name.split(' ')
    const initials = nameParts.map((part) => part[0]).join('')
    return initials.toUpperCase()
  }

  return (
    <>
      {studentInquiry && (
        <div className='followupForm-wrapper'>
          <div className='followupForm-header'>
            <BreadCrumbs breadCrumbsArr={breadCrumbsArr} />
          </div>
          <div className='inquiry-followup'>
            <div className='sidebar'>
              <div className='avatar'>{getInitials(studentInquiry?.name)}</div>
              <h2>{capitalizeFirstLetter(studentInquiry?.name)}</h2>
              <div className='name-div'>
                <img src={locaionIcon} />
                <p>{studentInquiry?.permanentArea ? studentInquiry?.permanentArea : 'N/A'}</p>
              </div>
              <div className='name-div'>
                <img src={CourseIcon} />
                <p>{studentInquiry?.courseName ? capitalizeFirstLetter(studentInquiry?.courseName) : 'N/A'}</p>
              </div>
              <button className='call-button'>Call: 91+{studentInquiry.phone}</button>
            </div>
            <div className='content-container'>
              <div className='tabs'>
                <button
                  className={`tab ${activeTab === 'followUp' ? 'active' : ''}`}
                  onClick={() => setActiveTab('followUp')}
                >
                  Follow-Up
                </button>
                <button
                  className={`tab ${activeTab === 'history' ? 'active' : ''}`}
                  onClick={() => setActiveTab('history')}
                >
                  History
                </button>
              </div>
              <div className='tab-content'>
                {activeTab === 'followUp' && <InquiryFollowUpForm inquiryId={id} studentInquiry={studentInquiry} />}
                {activeTab === 'history' && <FollowUpHistory followupHistory={followupHistory} />}
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  )
}

export default FollowupForm
